import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { TiPencil } from "react-icons/ti";
import { BsCheckCircleFill } from "react-icons/bs";
import { ImCross } from "react-icons/im";
import { useSelector } from "react-redux";
import { logEvent } from "../../../Common/utils/api/api";
import { selectEventsData } from "../../../Common/store/slices/common";

const EditableAxisName = ({ axisName, onConfirm, configId, ...props }) => {
  const [modeEdition, setModeEdition] = useState(false);
  const [newName, setNewName] = useState(null);
  const wrapperRef = useRef(null);

  const handleConfirmSaveName = () => {
    if (!newName) {
      return;
    }
    onConfirm(newName);
    setModeEdition(false);
  };

  const eventsData = useSelector(selectEventsData);

  const handleClickEditName = () => {
    logEvent(eventsData.locale, eventsData.types.editAxisName, eventsData.tags.none, configId);

    setNewName(axisName);
    setModeEdition(true);
  };

  const handleCancelSaveName = () => {
    setModeEdition(false);
  };

  const handleClickOutside = (event) => {
    if (!modeEdition) return;
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      handleConfirmSaveName();
    }
  };

  useEffect(() => {
    if (!modeEdition) return () => {};
    // console.log("Adding event listener", axisId);
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // console.log("Removing event listener", axisId);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modeEdition]);

  return (
    <div
      ref={wrapperRef}
      className="EditableAxisName col-span-1 axe-title text-base flex items-center space-x-3 max-w-full"
      {...props}
    >
      {!modeEdition ? (
        <>
          <span
            title={axisName}
            className="text-gray-600 font-bold print:whitespace-normal whitespace-nowrap overflow-hidden text-ellipsis max-w-[200px]"
          >
            {axisName}
          </span>
          <TiPencil
            onClick={(e) => {
              e.stopPropagation();
              handleClickEditName();
            }}
            className="text-secondary cursor-pointer flex-shrink-0 print:hidden"
          />
        </>
      ) : (
        <div className="flex items-center space-x-2">
          <input
            required
            type="text"
            value={newName}
            onChange={(e) => {
              e.stopPropagation();
              setNewName(e.target.value);
            }}
            onClick={(e) => {
              e.stopPropagation();
            }}
            // on click on enter => save
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.stopPropagation();
                handleConfirmSaveName();
              }
            }}
            className="invalid:border-red-500 border-gray-400 focus:border-gray-800 focus:ring-0 px-1 py-0.5 text-sm"
          />
          <ImCross
            className="z-30 cursor-pointer text-gray-400 text-sm opacity-90 hover:opacity-100"
            onClick={(e) => {
              e.stopPropagation();
              handleCancelSaveName();
            }}
          />
          <BsCheckCircleFill
            className="z-30 cursor-pointer text-secondary text-base opacity-90 hover:opacity-100"
            onClick={(e) => {
              e.stopPropagation();
              handleConfirmSaveName();
            }}
          />
        </div>
      )}
    </div>
  );
};

EditableAxisName.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  axisId: PropTypes.any.isRequired
};

export default EditableAxisName;
